"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateProfile = exports.createOperations = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var utils_1 = require("../../../shared/api/utils");
var core_1 = require("../../../shared/core");
var createOperations = function (body) {
    return Object.entries(body).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return ({
            op: 'replace',
            path: "/".concat(key === 'emailAddress' ? 'email' : key),
            value: value,
        });
    });
};
exports.createOperations = createOperations;
var useUpdateProfile = function (_a) {
    var customerId = _a.customerId, accountId = _a.accountId;
    var retailer = core_1.configService.getConfig().retailer;
    var _b = __read((0, kapi_1.useUpdateCustomerMutation)(), 2), mutate = _b[0], loading = _b[1].loading;
    var handleMutation = function (body, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        var operations = (0, exports.createOperations)(body);
        mutate({
            update: (0, utils_1.updateCache)({
                document: kapi_1.ProfileDocument,
                variables: { customerId: customerId, accountId: accountId },
                newData: { customer: body },
            }),
            variables: {
                updateCustomerId: customerId,
                realm: retailer.region === 'AUS' ? 'oea' : 'ovo-energy',
                operations: operations,
            },
            onCompleted: onCompleted,
            onError: onError,
        });
    };
    return {
        mutate: handleMutation,
        loading: loading,
    };
};
exports.useUpdateProfile = useUpdateProfile;
